export enum Client {
  Incyte = 'incyte',
  Hexal = 'hexal',
  Novartis = 'novartis',
  GSK = 'gsk',
  Seqirus = 'seqirus',
}
export enum IncyteInstance {
  Default = 'incyte',
  Onko = 'onko',
  Derma = 'derma',
}
export enum HexalInstance {
  Default = 'hexal',
}
export enum NovartisInstance {
  Default = 'novartis',
}
export enum GSKInstance {
  Default = 'gsk',
}
export enum SeqirusInstance {
  Default = 'seqirus',
}
